import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, DialogV2, styled } from '@withjoy/joykit';
import type { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledDialogV2 = styled(DialogV2)``;
export const StyledDialogV2CloseButton = styled(DialogV2.CloseButton)``;
export const StyledDialogV2BodyContainer = styled(Box)``;
export const StyledVideoContainer = styled(Box)``;
export const StyledCtaContainer = styled(Box)``;
export const StyledEyebrow = styled(Box)``;
export const StyledTitle = styled(Box)``;

export const dialogV2BodyStyles: CSSObject = {
  backgroundColor: 'rgb(0, 0, 0)',
  height: '100vh',
  width: '100vw',
  padding: 0,
};

export const dialogV2BodyContainerStyles: CSSObject = {
  height: 'inherit',
  minHeight: '600px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '12vh',
};
export const dialogV2VideoContainerStyles: CSSObject = {
  height: ['58vw', '56.25vw', null, null, '47vw'],
  width: ['100vw', '93vw', null, null, '80vw'],
};

export const dialogV2CtaContainerStyles: CSSObject = {
  position: ['absolute', 'absolute', 'static'],
  bottom: ['16vh'],
  display: 'flex',
  flexDirection: ['column', null, 'row'],
  justifyContent: ['flex-start', 'space-between'],
  alignItems: ['center', 'center', null],
  color: 'white',
  rowGap: ['15px', '0px'],
  padding: ['15px', '0px'],
  width: ['100vw', '93vw', null, null, '80vw'],
  ['& button']: {
    color: 'white',
    borderColor: 'white',
    width: ['85vw', '85vw', '205px'],
    _hover: {
      color: 'white',
      borderColor: 'white',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
};

export const dialogV2MobileCtaContainerStyles: CSSObject = {
  color: 'white',
  rowGap: ['15px', '0px'],
  padding: ['15px', '0px'],
  width: ['100vw', '93vw', null, null, '80vw'],
};

export const dialogV2CloseButtonStyles: StyleSystemProps = {
  color: 'white',
  width: 40,
  height: 40,
};

export const styles = {
  dialogV2Body: dialogV2BodyStyles,
  dialogV2BodyContainer: dialogV2BodyContainerStyles,
  dialogV2VideoContainer: dialogV2VideoContainerStyles,
  dialogV2CtaContainer: dialogV2CtaContainerStyles,
  dialogV2MobileCtaContainer: dialogV2MobileCtaContainerStyles,
  dialogV2CloseButton: dialogV2CloseButtonStyles,
};
